import {
  getTimeValue,
  PropertyType,
  SortDirection,
  sortValues
} from "@utils/sortUtil";

import { AzureApplicationUserModel } from "./models/api-users-models";

export function sortApiUsers(
  users: AzureApplicationUserModel[] | undefined,
  activeSort: string | undefined,
  sortDirection: SortDirection
): AzureApplicationUserModel[] {
  return sortValues<AzureApplicationUserModel>(
    users,
    activeSort,
    sortDirection,
    getSortValues
  );
}

function getSortValues(
  activeSort: string | undefined,
  a: AzureApplicationUserModel,
  b: AzureApplicationUserModel
) {
  let valueA: PropertyType;
  let valueB: PropertyType;

  switch (activeSort) {
    case "id":
      valueA = a.id;
      valueB = b.id;
      break;
    case "name":
      valueA = a.name;
      valueB = b.name;
      break;
    case "createdOn":
      valueA = getTimeValue(new Date(a.createdOn));
      valueB = getTimeValue(new Date(b.createdOn));
      break;
    case "secretStatus":
      valueA = a.secretStatus;
      valueB = b.secretStatus;
      break;
  }

  return { valueA, valueB };
}
